<template>
  <div class="container text-right variation-generator">
    <div class="row my-3">
      <b-col md="4" class="mb-4">
        <feature-search @selectedFeature="setSelectedFeatures" :filterFunction="filterFeatureItem"/>
      </b-col>
      <b-col md="8">
        <p class="m-0 p-0">موارد انتخاب شده:</p>

        <div class="btn btn-primary d-inline-block m-1" v-for="(item,index) in selectedFeatures" :key="item.id || index"
             @click="removeSelectedFeatureItem(index)">
        <span>
          {{ item.name }}
        <b-icon class="h4" icon="x"/>
        </span>
        </div>
      </b-col>
      <div class="col-lg-12 text-left">
        <b-btn variant="primary" @click="generateFeatureAttributesCombination()">ساخت حالات</b-btn>
      </div>
    </div>

    <hr>

    <div class="variation-combos">
      <div class="variation-combo" v-for="(feature, index) in featureCombinationOptions" :key="index">
        <span class="variation-combo__name">{{ setCombinationFeatureItemName(feature) }}</span>
        <button type="button" class="variation-combo__add" @click="addFeatureToProductWrapper(feature)" title="افزودن">
          <b-icon icon="check-circle"/>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import FeatureSearch from "./FeatureSearch.vue";
import {addFeatureToProduct, baseFeature} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "VariationFeatureGenerator",
  components: {FeatureSearch},
  props: {
    product: {},
  },
  data() {
    return {
      baseFeature,
      searchWord: '',
      selectedFeatures: [],
      featureCombinationOptions: [],
    };
  },
  computed: {
    ...mapGetters({
      features: 'Feature/getFilteredFeatures'
    }),
    isPageInUpdateMode() {
      return this.$route.params.slug
    }
  },
  methods: {
    addFeatureToProduct,
    generateHash,
    searchFeature() {
      if (this.searchWord != "") {
        const searchWord = {words: this.searchWord};
        this.$store.dispatch("Feature/filteredFeatures", searchWord);
      }
    },
    filterFeatureItem(featureItem) {
      return featureItem.type === 'list'
    },
    setSelectedFeatures(feature) {
      this.selectedFeatures.push(feature)
    },
    removeSelectedFeatureItem(featureIndex) {
      this.selectedFeatures.splice(featureIndex, 1)
    },
    cartesian(arrays) {
      let result = [];
      let index = 0;

      function addToResult(prefix) {
        if (index === arrays.length - 1) {
          for (let i = 0; i < arrays[index].length; i++) {
            result.push(prefix.concat([arrays[index][i]]));
          }
        } else {
          for (let i = 0; i < arrays[index].length; i++) {
            index++;
            addToResult(prefix.concat([arrays[index - 1][i]]));
            index--;
          }
        }
      }

      addToResult([]);
      return result;
    },
    generateFeatureAttributesCombination() {

      let attributes = []
      this.selectedFeatures.forEach((item, index) => {
        attributes[index] = []
        item.feature_attributes.forEach(attributeItem => {
          attributes[index].push(attributeItem)
        })
      })


      this.featureCombinationOptions = this.cartesian(attributes)
    },
    setCombinationFeatureItemName(featureItem) {
      let name = [];
      featureItem.forEach(item => {
        name.push(item.value)
      })
      return name.join(' - ')
    },
    addFeatureToProductWrapper(feature) {

      this.addFeatureToProduct({selectedFeature: this.selectedFeatures, attributes: feature}, this.product)
      toast("با موفقیت اضافه شد", "با موفقیت اضافه شد")
    }
  }
}
</script>

<style scoped>
.variation-combos {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.variation-combo {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  max-width: 100%;
  padding: 0.45rem 0.45rem 0.45rem 0.8rem;
  border-radius: 999px;
  background: #f5f5f6;
  border: 1px solid rgba(30, 30, 30, 0.1);
}

.variation-combo__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  color: #1e1e1e;
}

.variation-combo__add {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  cursor: pointer;
  flex: 0 0 auto;
}
</style>
